// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Switch Component */
:host([label-position=inline-start]) .ids-input,
:host([label-position=inline-start]) .ids-textarea {
  display: flex;
  align-items: var(--ids-label-align-y, center);
  gap: 8px;
}
:host([label-position=inline-start]) .ids-input label,
:host([label-position=inline-start]) .ids-textarea label {
  width: var(--ids-label-width);
  padding-block: var(--ids-label-padding-block);
  padding-inline-end: 0;
  box-sizing: border-box;
  flex-shrink: 0;
}
:host([label-position=inline-start]) .ids-input .validation-message,
:host([label-position=inline-start]) .ids-textarea .validation-message {
  width: 100%;
  margin-block-start: var(--ids-space-2xs);
}
@media (max-width: 927px) {
  :host([label-position=inline-start]) .ids-input .validation-message,
  :host([label-position=inline-start]) .ids-textarea .validation-message {
    margin-inline-start: 0;
  }
}
:host([label-position=inline-start]) .ids-input + .validation-message,
:host([label-position=inline-start]) .ids-textarea + .validation-message {
  min-width: min-content;
  margin-block-start: calc(0px - var(--ids-space-2xs));
  margin-inline-start: calc(var(--ids-label-width) + 6px);
}
:host([label-position=inline-start]) .ids-input.xs + .validation-message,
:host([label-position=inline-start]) .ids-textarea.xs + .validation-message {
  position: relative;
  inset-inline-start: 6px;
  margin-inline-start: calc(var(--ids-label-width));
}
:host([label-position=inline-start]) .ids-input .ids-label-text,
:host([label-position=inline-start]) .ids-textarea .ids-label-text {
  margin-bottom: unset;
}
@media (width > 320px) {
  :host([label-position=inline-start]) .ids-input .ids-label-text,
  :host([label-position=inline-start]) .ids-textarea .ids-label-text {
    margin-inline-end: 0;
  }
}
@container (width > \$breakpoint-xs) {
  :host([label-position=inline-start]) .ids-input .ids-label-text,
  :host([label-position=inline-start]) .ids-textarea .ids-label-text {
    margin-inline-end: 0;
  }
}
@media (min-width: 767px) {
  :host([label-position=inline-start]) .ids-input label,
  :host([label-position=inline-start]) .ids-textarea label {
    flex: 0 0 auto;
    margin-bottom: unset;
    order: 1;
  }
  :host([label-position=inline-start]) .ids-input .field-container,
  :host([label-position=inline-start]) .ids-textarea .field-container {
    order: 2;
  }
  :host([label-position=inline-start]) .ids-input .validation-message,
  :host([label-position=inline-start]) .ids-textarea .validation-message {
    flex: 1 1 100%;
    min-width: 100%;
    order: 3;
    margin-block-start: calc(0px - var(--ids-space-2xs));
  }
  :host([label-position=inline-start]) .ids-input.wrapped .validation-message,
  :host([label-position=inline-start]) .ids-textarea.wrapped .validation-message {
    margin-block-start: calc(0px - var(--ids-space-2xs));
    margin-inline-start: calc(var(--ids-label-width) + 6px);
  }
}
:host([label-position=inline-start]) .ids-checkbox {
  container-type: inline-size;
  margin-top: var(--ids-space-00);
}
@container (width >= 200px) {
  :host([label-position=inline-start]) .ids-checkbox {
    display: flex;
    flex-wrap: wrap;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start]) .ids-checkbox label {
    --ids-checkbox-padding-inline-start: 0;
    padding-block: var(--ids-label-padding-block);
    padding-inline-end: var(--ids-label-padding-inline-end);
    box-sizing: border-box;
  }
  :host([label-position=inline-start]) .ids-checkbox .field-container {
    flex: 1;
  }
  :host([label-position=inline-start]) .ids-checkbox .validation-message {
    width: 100%;
    margin-inline-start: calc(var(--ids-label-width) + 0.4rem);
    margin-block-start: 3px;
  }
  :host([label-position=inline-start]) .ids-checkbox input[type=checkbox] ~ .checkmark {
    left: unset;
    inset-inline-end: -1.5rem;
  }
  :host([label-position=inline-start]) .ids-checkbox label.required .label-checkbox::after {
    right: 30px;
  }
}

:host([label-position=inline-start][horizontal-aligned]) .ids-checkbox {
  container-type: normal;
}
@media (width <= 320px) {
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox {
    display: flex;
    flex-wrap: wrap;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox label {
    --ids-checkbox-padding-inline-start: 0;
    padding-block: var(--ids-label-padding-block);
    padding-inline-end: var(--ids-label-padding-inline-end);
    box-sizing: border-box;
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox .field-container {
    flex: 1;
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox .validation-message {
    width: 100%;
    margin-inline-start: calc(var(--ids-label-width) + 0.4rem);
    margin-block-start: 3px;
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox input[type=checkbox] ~ .checkmark {
    left: unset;
    inset-inline-end: -1.5rem;
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox label.required .label-checkbox::after {
    right: 30px;
  }
}

:host([label-position=inline-start][label-alignment=end]) .ids-input label,
:host([label-position=inline-start][label-alignment=end]) .ids-textarea label {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
}
@container (width < 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-input label,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea label {
    justify-content: flex-start;
  }
}
@media (width < 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-input label,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea label {
    justify-content: flex-start;
  }
}
:host([label-position=inline-start][label-alignment=end]) .ids-input label.required::after,
:host([label-position=inline-start][label-alignment=end]) .ids-textarea label.required::after {
  margin-inline-end: 0;
}
@container (width < 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-input,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea {
    display: block;
  }
}
@media (width < 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-input,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea {
    display: block;
  }
}
:host([label-position=inline-start][label-alignment=end]) .field-container {
  flex: 1;
}

:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-input,
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-input,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-textarea {
  display: flex;
  flex-wrap: nowrap;
}
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-input label,
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea label,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-input label,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-textarea label {
  flex-shrink: 0;
}
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-input .field-container,
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea .field-container,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-input .field-container,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-textarea .field-container {
  min-width: 0;
  flex: 0 1 auto;
}
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-input .validation-message,
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-input .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-textarea .validation-message {
  width: auto;
  margin-inline-start: 0;
}
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-input:not(.xs),
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-input:not(.xs) {
  gap: var(--ids-space-2, 0.5rem);
}

:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea {
  display: grid;
  gap: 0;
  grid-template-columns: auto minmax(0, 1fr);
  column-gap: var(--ids-space-2, 0.5rem);
}
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input label,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea label {
  grid-column: 1;
  grid-row: 1;
}
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input .field-container,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea .field-container {
  grid-column: 2;
  grid-row: 1;
  min-width: 0;
}
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea .validation-message {
  grid-column: 1/-1;
  grid-row: 2;
  width: auto;
  margin-inline-start: 0;
  margin-block-start: var(--ids-space-2xs);
}
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input.wrapped .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea.wrapped .validation-message {
  grid-column: 2;
  margin-inline-start: 0;
}

@media (width > 320px) {
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group ids-text.group-label-text {
    width: var(--ids-label-width);
    flex-shrink: 0;
  }
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
  }
}
@media (width < 320px) {
  :host([label-position=inline-start][label-break=shrink-value]) .ids-input,
  :host([label-position=inline-start][label-break=shrink-value]) .ids-textarea {
    display: block;
  }
}
@container (width < 320px) {
  :host([label-position=inline-start][label-break=shrink-value]) .ids-input,
  :host([label-position=inline-start][label-break=shrink-value]) .ids-textarea {
    flex-wrap: wrap;
  }
}

@media (width > 320px) {
  :host([label-position=inline-start][label-break=shrink-label]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start][label-break=shrink-label]) .ids-radio-group ids-text.group-label-text {
    width: var(--ids-label-width);
    flex: 0 1 auto;
  }
  :host([label-position=inline-start][label-break=shrink-label]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
  }
}

:host([label-position=inline-start][label-break=break]) .ids-input,
:host([label-position=inline-start][label-break=break]) .ids-textarea {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
:host([label-position=inline-start][label-break=break]) .ids-input label,
:host([label-position=inline-start][label-break=break]) .ids-textarea label {
  width: auto;
  flex-shrink: 0;
}
:host([label-position=inline-start][label-break=break]) .ids-input .field-container,
:host([label-position=inline-start][label-break=break]) .ids-textarea .field-container {
  min-width: 0;
  flex: 0 1 auto;
}
:host([label-position=inline-start][label-break=break]) .ids-input .validation-message,
:host([label-position=inline-start][label-break=break]) .ids-textarea .validation-message {
  width: auto;
  margin-inline-start: 0;
}

:host([label-position=inline-start][label-width="0px"]) .ids-label-text,
:host([label-position=inline-start][label-width="0"]) .ids-label-text {
  display: none;
}

:host([label-position=inline-end][label-break=shrink-value]) .ids-input,
:host([label-position=inline-end][label-break=shrink-value]) .ids-textarea {
  display: flex;
}
:host([label-position=inline-end][label-break=shrink-value]) .ids-input label,
:host([label-position=inline-end][label-break=shrink-value]) .ids-textarea label {
  flex-shrink: 0;
  order: 2;
}
:host([label-position=inline-end][label-break=shrink-value]) .ids-input .field-container,
:host([label-position=inline-end][label-break=shrink-value]) .ids-textarea .field-container {
  min-width: 0;
  flex: 0 1 auto;
  order: 1;
}
:host([label-position=inline-end][label-break=shrink-value]) .ids-input {
  gap: var(--ids-space-2, 0.5rem);
}

@media (width > 320px) {
  :host([label-position=inline-end][label-break=shrink-label]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-end][label-break=shrink-label]) .ids-radio-group ids-text.group-label-text {
    width: var(--ids-label-width);
    justify-content: end;
    flex: 0 1 auto;
    order: 2;
  }
  :host([label-position=inline-end][label-break=shrink-label]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    order: 1;
  }
}

:host([label-position=inline-end][label-break=break]) .ids-input,
:host([label-position=inline-end][label-break=break]) .ids-textarea {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
:host([label-position=inline-end][label-break=break]) .ids-input label,
:host([label-position=inline-end][label-break=break]) .ids-textarea label {
  width: auto;
  flex-shrink: 0;
  order: 2;
}
:host([label-position=inline-end][label-break=break]) .ids-input .field-container,
:host([label-position=inline-end][label-break=break]) .ids-textarea .field-container {
  min-width: 0;
  flex: 0 1 auto;
  order: 1;
}
:host([label-position=inline-end][label-break=break]) .ids-input .validation-message,
:host([label-position=inline-end][label-break=break]) .ids-textarea .validation-message {
  margin-inline-start: 0;
  order: 3;
}
:host([label-position=inline-end][label-break=break]) .ids-input {
  gap: var(--ids-space-2, 0.5rem);
}

:host([label-position=inline-start]) {
  --ids-label-width: var(--ids-label-width-inline-start);
}

:host([label-position=inline-start][label-wrap=ellipsis-no-stretch]) .ids-input label,
:host([label-position=inline-start][label-wrap=ellipsis-no-stretch]) .ids-textarea label,
:host([label-position=inline-start][label-wrap=wrap-no-stretch]) .ids-input label,
:host([label-position=inline-start][label-wrap=wrap-no-stretch]) .ids-textarea label {
  align-self: var(--ids-label-align-y, center);
}
:host([label-position=inline-start][label-wrap=ellipsis-no-stretch]) .ids-input .ids-label-text,
:host([label-position=inline-start][label-wrap=ellipsis-no-stretch]) .ids-textarea .ids-label-text,
:host([label-position=inline-start][label-wrap=wrap-no-stretch]) .ids-input .ids-label-text,
:host([label-position=inline-start][label-wrap=wrap-no-stretch]) .ids-textarea .ids-label-text {
  overflow: visible;
}

@media (width > 767px) {
  :host([label-position=inline-start]) .ids-textarea {
    max-width: calc(370px + var(--ids-label-width));
  }
  :host([label-position=inline-start]) .ids-textarea .textarea-field {
    width: calc(370px + var(--ids-label-width));
  }
}
@media (width > 767px) {
  :host([label-position=inline-start]) .ids-filter-field {
    display: flex;
    flex-wrap: wrap;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start]) .ids-filter-field label {
    width: var(--ids-label-width);
    padding-block: var(--ids-label-padding-block);
    padding-inline-end: var(--ids-label-padding-inline-end);
    box-sizing: border-box;
  }
  :host([label-position=inline-start]) .ids-filter-field #operator-button {
    position: relative;
    inset-inline-start: var(--ids-label-width);
  }
  :host([label-position=inline-start]) .ids-filter-field .validation-message {
    width: 100%;
    margin-block-start: var(--ids-space-2xs);
  }
}
@media (width < 767px) {
  :host([label-position=inline-start][dir=rtl]) .ids-checkbox label {
    --ids-checkbox-padding-inline-start: inherit;
  }
  :host([label-position=inline-start][dir=rtl]) .ids-checkbox .validation-message {
    margin-inline-start: initial;
  }
}

@media (min-width: 767px) {
  :host([label-position=inline-start][dir=rtl]) .ids-checkbox input[type=checkbox] ~ .checkmark {
    right: initial;
  }
  :host([label-position=inline-start][dir=rtl]) .ids-checkbox .validation-message {
    margin-block-start: 0;
  }
}
@media (width > 767px) {
  :host([label-position=inline-start]) .ids-radio-group,
  :host([label-position=inline-end]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
    gap: var(--ids-space-2, 0.5rem);
  }
  :host([label-position=inline-start]) .ids-radio-group ids-text.group-label-text,
  :host([label-position=inline-end]) .ids-radio-group ids-text.group-label-text {
    min-width: var(--ids-label-width);
  }
  :host([label-position=inline-start]) .ids-radio-group slot,
  :host([label-position=inline-end]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
  }
  :host([label-position=inline-end]) .ids-radio-group ids-text.group-label-text {
    justify-content: end;
    order: 2;
  }
  :host([label-position=inline-end]) .ids-radio-group slot {
    order: 1;
  }
}
@media (width < 767px) {
  :host([label-position=inline-end]):not([label-break]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
    gap: var(--ids-space-2, 0.5rem);
    flex-direction: column;
  }
  :host([label-position=inline-end]):not([label-break]) .ids-radio-group ids-text.group-label-text {
    min-width: var(--ids-label-width);
    order: 2;
  }
  :host([label-position=inline-end]):not([label-break]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
    order: 1;
  }
}
@media (width > 767px) {
  :host([label-position=inline-start]) .ids-switch {
    display: flex;
    flex-wrap: wrap;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start]) .ids-switch label {
    width: var(--ids-label-width);
    padding-block: var(--ids-label-padding-block);
    padding-inline-end: var(--ids-label-padding-inline-end);
    padding-inline-start: 0;
    box-sizing: border-box;
  }
  :host([label-position=inline-start]) .ids-switch input[type=checkbox] ~ .slider {
    left: unset;
    right: -45px;
  }
  :host([label-position=inline-start][dir=rtl]) .ids-switch input[type=checkbox] ~ .slider {
    left: 45px;
    right: initial;
  }
}
@media (width > 767px) {
  :host([label-position=inline-start]) .ids-data-label {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start]) .ids-data-label .label {
    width: var(--ids-label-width);
    padding-block: var(--ids-label-padding-block);
    box-sizing: border-box;
    margin-block-end: 0;
    white-space: nowrap;
  }
  :host([label-position=inline-start]) .ids-data-label .data,
  :host([label-position=inline-start]) .ids-data-label .description {
    display: flex;
    padding-block: var(--ids-label-padding-block);
  }
}
@media (max-width: 320px) {
  :host([label-position=inline-start]) .ids-input,
  :host([label-position=inline-start]) .ids-textarea,
  :host([label-position=inline-start]) .ids-filter-field {
    display: block;
    flex-direction: column;
    align-items: unset;
  }
  :host([label-position=inline-start]) .ids-input label,
  :host([label-position=inline-start]) .ids-textarea label,
  :host([label-position=inline-start]) .ids-filter-field label {
    width: auto;
    text-align: start;
    padding-inline: 0;
  }
  :host([label-position=inline-start]) .ids-input .validation-message,
  :host([label-position=inline-start]) .ids-textarea .validation-message,
  :host([label-position=inline-start]) .ids-filter-field .validation-message {
    margin-inline-start: 0;
  }
  :host([label-position=inline-end]) .ids-input,
  :host([label-position=inline-end]) .ids-textarea,
  :host([label-position=inline-end]) .ids-filter-field {
    display: block;
    flex-direction: column;
    align-items: unset;
    gap: var(--ids-space-2, 0.5rem);
  }
  :host([label-position=inline-end]) .ids-input label,
  :host([label-position=inline-end]) .ids-textarea label,
  :host([label-position=inline-end]) .ids-filter-field label {
    width: auto;
    text-align: start;
    padding-inline: 0;
  }
  :host([label-position=inline-end]) .ids-input .validation-message,
  :host([label-position=inline-end]) .ids-textarea .validation-message,
  :host([label-position=inline-end]) .ids-filter-field .validation-message {
    margin-inline-start: 0;
  }
}
:host .ids-input label,
:host .ids-input .label,
:host .ids-textarea label,
:host .ids-textarea .label,
:host .ids-checkbox label,
:host .ids-checkbox .label,
:host .ids-radio label,
:host .ids-radio .label,
:host .ids-switch label,
:host .ids-switch .label,
:host .ids-data-label label,
:host .ids-data-label .label,
:host .ids-filter-field label,
:host .ids-filter-field .label {
  width: var(--ids-label-width);
}

.ids-switch {
  color: var(--ids-switch-label-color-text-default);
  margin-block-end: var(--ids-space-sm);
}
.ids-switch.no-margins {
  margin-block-end: var(--ids-space-none);
}
.ids-switch label {
  cursor: pointer;
  user-select: none;
  padding-inline-start: calc(var(--ids-space-xl) + var(--ids-space-xs));
  position: relative;
  display: inline-flex;
  align-items: center;
}
.ids-switch input[type=checkbox] {
  opacity: 0;
  width: 0;
  height: 0;
}
.ids-switch input[type=checkbox] ~ .slider {
  width: var(--ids-space-xl);
  height: var(--ids-space-md);
  position: absolute;
  inset-inline-start: 0;
  background-color: var(--ids-switch-pole-color-background-default);
  border-radius: var(--ids-border-radius-circle);
  border: 1px solid var(--ids-switch-pole-color-border-default);
  box-sizing: border-box;
  transition: all var(--ids-motion-duration) var(--ids-motion-ease);
}
.ids-switch input[type=checkbox] ~ .slider::after {
  content: "";
  width: 20px;
  height: 20px;
  position: absolute;
  inset-inline-start: 1px;
  top: 1px;
  background-color: var(--ids-switch-toggle-color-background-default);
  border-radius: var(--ids-border-radius-circle);
  box-shadow: 0 0 2px 0 var(--ids-color-neutral-40);
  transition: all var(--ids-motion-duration) var(--ids-motion-ease);
}
.ids-switch input[type=checkbox]:focus ~ .slider {
  box-shadow: var(--ids-switch-shadow-focus);
}
.ids-switch input[type=checkbox]:checked ~ .slider {
  border-color: var(--ids-color-action-default);
  background-color: var(--ids-color-action-default);
}
.ids-switch input[type=checkbox]:checked ~ .slider::after {
  inset-inline-start: 17px;
}
.ids-switch.compact input[type=checkbox]:checked ~ .slider::after {
  inset-inline-start: 15px;
}
.ids-switch.compact label {
  padding-inline-start: calc(34px + var(--ids-space-xs));
}
.ids-switch.compact input[type=checkbox] ~ .slider {
  width: 34px;
  height: 20px;
}
.ids-switch.compact input[type=checkbox] ~ .slider::after {
  width: var(--ids-space-sm);
  height: var(--ids-space-sm);
}
.ids-switch.disabled {
  opacity: var(--ids-switch-disabled-opacity);
}
.ids-switch.disabled label {
  cursor: default;
}
.ids-switch.label-state-hidden .label-text {
  visibility: hidden;
}
.ids-switch.label-state-collapsed .label-text {
  display: none;
}

:host([label-position=start]) .ids-switch label {
  padding-inline-start: 0;
}
:host([label-position=start]) .ids-switch:not(.compact) label {
  padding-inline-end: calc(var(--ids-space-xl) + var(--ids-space-xs) + 7px);
}
:host([label-position=start]) .ids-switch.compact label {
  padding-inline-end: calc(34px + var(--ids-space-xs) + 7px);
}
:host([label-position=start]) .ids-switch input[type=checkbox] {
  margin: 0;
}
:host([label-position=start]) .ids-switch input[type=checkbox] ~ .slider {
  inset-inline-start: unset;
  inset-inline-end: 0;
}

:host([size]), :host([size]) .ids-switch, :host([size]) label {
  width: 100%;
  box-sizing: border-box;
}

:host([size=xs]) label {
  max-width: var(--ids-input-width-10);
}

:host([size=sm]) label {
  max-width: var(--ids-input-width-20);
}

:host([size=mm]) label {
  max-width: var(--ids-input-width-30);
}

:host([size=md]) label {
  max-width: var(--ids-input-width-40);
}

:host([size=lg]) label {
  max-width: var(--ids-input-width-50);
}

:host([size=full]) label {
  max-width: var(--ids-input-width-full);
}`, "",{"version":3,"sources":["webpack://./src/components/ids-switch/ids-switch.scss","webpack://./src/themes/mixins/ids-label-position-mixin.scss"],"names":[],"mappings":"AAAA,yBAAA;ACKE;;EAEE,aAAA;EACA,6CAAA;EACA,QAAA;ADHJ;ACMI;;EACE,6BAAA;EACA,6CAAA;EACA,qBAAA;EACA,sBAAA;EACA,cAAA;ADHN;ACOI;;EACE,WAAA;EACA,wCAAA;ADJN;ACMM;EAJF;;IAKI,sBAAA;EDFN;AACF;ACKI;;EACE,sBAAA;EACA,oDAAA;EACA,uDAAA;ADFN;ACKI;;EACE,kBAAA;EACA,uBAAA;EACA,iDAAA;ADFN;ACKI;;EACE,oBAAA;ADFN;ACIM;EAHF;;IAII,oBAAA;EDAN;AACF;ACEM;EAPF;;IAQI,oBAAA;EDEN;AACF;ACCI;EACE;;IACE,cAAA;IACA,oBAAA;IACA,QAAA;EDEN;ECCI;;IACE,QAAA;EDEN;ECCI;;IACE,cAAA;IACA,eAAA;IACA,QAAA;IACA,oDAAA;EDEN;ECEM;;IACE,oDAAA;IACA,uDAAA;EDCR;AACF;ACKE;EACE,2BAAA;EACA,+BAAA;ADHJ;ACKI;EAJF;IAKI,aAAA;IACA,eAAA;IACA,+CAAA;EDFJ;ECKI;IACE,sCAAA;IAEA,6CAAA;IACA,uDAAA;IACA,sBAAA;EDJN;ECOI;IACE,OAAA;EDLN;ECQI;IACE,WAAA;IACA,0DAAA;IACA,uBAAA;EDNN;ECSI;IACE,WAAA;IACA,yBAAA;EDPN;ECUI;IACE,WAAA;EDRN;AACF;;ACeE;EACE,sBAAA;ADZJ;ACcI;EAHF;IAII,aAAA;IACA,eAAA;IACA,+CAAA;EDXJ;ECaI;IACE,sCAAA;IAEA,6CAAA;IACA,uDAAA;IACA,sBAAA;EDZN;ECeI;IACE,OAAA;EDbN;ECgBI;IACE,WAAA;IACA,0DAAA;IACA,uBAAA;EDdN;ECiBI;IACE,WAAA;IACA,yBAAA;EDfN;ECkBI;IACE,WAAA;EDhBN;AACF;;ACwBI;;EACE,oBAAA;EACA,mBAAA;EACA,yBAAA;ADpBN;ACsBM;EALF;;IAMI,2BAAA;EDlBN;AACF;ACoBM;EATF;;IAUI,2BAAA;EDhBN;AACF;ACmBQ;;EACE,oBAAA;ADhBV;ACqBI;EAtBF;;IAuBI,cAAA;EDjBJ;AACF;ACmBI;EA1BF;;IA2BI,cAAA;EDfJ;AACF;ACkBE;EACE,OAAA;ADhBJ;;ACuBE;;;;EAEE,aAAA;EACA,iBAAA;ADlBJ;ACoBI;;;;EACE,cAAA;ADfN;ACkBI;;;;EACE,YAAA;EACA,cAAA;ADbN;ACiBI;;;;EACE,WAAA;EACA,sBAAA;ADZN;ACgBE;;EACE,+BAAA;ADbJ;;ACmBE;;EAEE,aAAA;EACA,MAAA;EACA,0CAAA;EACA,sCAAA;ADhBJ;ACkBI;;EACE,cAAA;EACA,WAAA;ADfN;ACkBI;;EACE,cAAA;EACA,WAAA;EACA,YAAA;ADfN;ACkBI;;EACE,iBAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,wCAAA;ADfN;ACkBI;;EACE,cAAA;EACA,sBAAA;ADfN;;ACqBE;EACE;IACE,aAAA;IACA,+CAAA;EDlBJ;ECoBI;IACE,6BAAA;IACA,cAAA;EDlBN;ECqBI;IACE,aAAA;IACA,sBAAA;IACA,cAAA;EDnBN;AACF;ACuBE;EACE;;IAEE,cAAA;EDrBJ;AACF;ACwBE;EACE;;IAEE,eAAA;EDtBJ;AACF;;AC2BE;EACE;IACE,aAAA;IACA,+CAAA;EDxBJ;EC0BI;IACE,6BAAA;IACA,cAAA;EDxBN;EC2BI;IACE,aAAA;IACA,sBAAA;IACA,cAAA;EDzBN;AACF;;AC+BE;;EAEE,aAAA;EACA,sBAAA;EACA,oBAAA;AD5BJ;AC8BI;;EACE,WAAA;EACA,cAAA;AD3BN;AC8BI;;EACE,YAAA;EACA,cAAA;AD3BN;AC+BI;;EACE,WAAA;EACA,sBAAA;AD5BN;;ACoCE;;EACE,aAAA;ADhCJ;;ACuCE;;EAEE,aAAA;ADpCJ;ACsCI;;EACE,cAAA;EACA,QAAA;ADnCN;ACsCI;;EACE,YAAA;EACA,cAAA;EACA,QAAA;ADnCN;ACuCE;EACE,+BAAA;ADrCJ;;AC0CE;EACE;IACE,aAAA;IACA,+CAAA;EDvCJ;ECyCI;IACE,6BAAA;IACA,oBAAA;IACA,cAAA;IACA,QAAA;EDvCN;EC0CI;IACE,aAAA;IACA,sBAAA;IACA,cAAA;IACA,QAAA;EDxCN;AACF;;AC8CE;;EAEE,aAAA;EACA,sBAAA;EACA,oBAAA;AD3CJ;AC6CI;;EACE,WAAA;EACA,cAAA;EACA,QAAA;AD1CN;AC6CI;;EACE,YAAA;EACA,cAAA;EACA,QAAA;AD1CN;AC8CI;;EACE,sBAAA;EACA,QAAA;AD3CN;AC+CE;EACE,+BAAA;AD7CJ;;ACiDA;EACE,sDAAA;AD9CF;;ACuDI;;;;EACE,4CAAA;ADjDN;ACoDI;;;;EACE,iBAAA;AD/CN;;ACqDA;EAEI;IACE,+CAAA;EDnDJ;ECqDI;IACE,2CAAA;EDnDN;AACF;ACyDA;EAEI;IACE,aAAA;IACA,eAAA;IACA,+CAAA;EDxDJ;EC0DI;IACE,6BAAA;IACA,6CAAA;IACA,uDAAA;IACA,sBAAA;EDxDN;EC4DI;IACE,kBAAA;IACA,0CAAA;ED1DN;EC8DI;IACE,WAAA;IACA,wCAAA;ED5DN;AACF;ACmEE;EAEI;IACE,4CAAA;EDlEN;ECqEI;IACE,4BAAA;EDnEN;AACF;;ACwEA;EAEI;IACE,cAAA;EDtEJ;ECyEE;IACE,qBAAA;EDvEJ;AACF;AC6EA;EAGI;;IACE,aAAA;IACA,+CAAA;IACA,+BAAA;ED5EJ;EC8EI;;IACE,iCAAA;ED3EN;EC8EI;;IACE,aAAA;IACA,sBAAA;ED3EN;ECiFE;IACE,oBAAA;IACA,QAAA;ED/EJ;ECkFE;IACE,QAAA;EDhFJ;AACF;ACqFA;EAEI;IACE,aAAA;IACA,+CAAA;IACA,+BAAA;IACA,sBAAA;EDpFJ;ECsFI;IACE,iCAAA;IACA,QAAA;EDpFN;ECuFI;IACE,aAAA;IACA,sBAAA;IACA,QAAA;EDrFN;AACF;AC2FA;EACE;IACE,aAAA;IACA,eAAA;IACA,+CAAA;EDzFF;EC2FE;IACE,6BAAA;IACA,6CAAA;IACA,uDAAA;IACA,uBAAA;IACA,sBAAA;EDzFJ;EC4FE;IACE,WAAA;IACA,YAAA;ED1FJ;EC+FE;IACE,UAAA;IACA,cAAA;ED7FJ;AACF;ACkGA;EACE;IACE,aAAA;IACA,mBAAA;IACA,QAAA;IACA,+CAAA;EDhGF;ECkGE;IACE,6BAAA;IACA,6CAAA;IACA,sBAAA;IACA,mBAAA;IACA,mBAAA;EDhGJ;ECmGE;;IAEE,aAAA;IACA,6CAAA;EDjGJ;AACF;ACsGA;EAEI;;;IAGE,cAAA;IACA,sBAAA;IACA,kBAAA;EDrGJ;ECuGI;;;IACE,WAAA;IACA,iBAAA;IACA,iBAAA;EDnGN;ECsGI;;;IACE,sBAAA;EDlGN;ECwGE;;;IAGE,cAAA;IACA,sBAAA;IACA,kBAAA;IACA,+BAAA;EDtGJ;ECwGI;;;IACE,WAAA;IACA,iBAAA;IACA,iBAAA;EDpGN;ECuGI;;;IACE,sBAAA;EDnGN;AACF;ACiHI;;;;;;;;;;;;;;EAEE,6BAAA;ADnGN;;AA5jBA;EACE,iDAAA;EACA,qCAAA;AA+jBF;AA7jBE;EACE,uCAAA;AA+jBJ;AA3jBE;EACE,eAAA;EACA,iBAAA;EACA,qEAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;AA6jBJ;AA1jBE;EACE,UAAA;EACA,QAAA;EACA,SAAA;AA4jBJ;AA1jBI;EACE,0BAhCS;EAiCT,2BAhCU;EAiCV,kBAAA;EACA,qBAAA;EACA,iEAAA;EACA,8CAAA;EACA,6DAAA;EACA,sBAAA;EACA,iEAAA;AA4jBN;AA1jBM;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,QAAA;EACA,mEAAA;EACA,8CAAA;EACA,iDAAA;EACA,iEAAA;AA4jBR;AAvjBM;EACE,0CAAA;AAyjBR;AAljBI;EACE,6CAAA;EACA,iDAAA;AAojBN;AAljBM;EACE,wBAAA;AAojBR;AA9iBI;EACE,wBAAA;AAgjBN;AA1iBI;EACE,sDAAA;AA4iBN;AAxiBM;EACE,WAtFe;EAuFf,YAxFgB;AAkoBxB;AAxiBQ;EACE,0BAAA;EACA,2BAAA;AA0iBV;AAniBE;EACE,2CAAA;AAqiBJ;AAniBI;EACE,eAAA;AAqiBN;AAjiBE;EACE,kBAAA;AAmiBJ;AAhiBE;EACE,aAAA;AAkiBJ;;AA1hBI;EACE,uBAAA;AA6hBN;AAzhBM;EACE,yEAAA;AA2hBR;AAthBM;EACE,0DAAA;AAwhBR;AAphBI;EACE,SAAA;AAshBN;AAphBM;EACE,yBAAA;EACA,mBAAA;AAshBR;;AA9gBE;EACE,WAAA;EACA,sBAAA;AAihBJ;;AA7gBA;EACE,oCAAA;AAghBF;;AA7gBA;EACE,oCAAA;AAghBF;;AA7gBA;EACE,oCAAA;AAghBF;;AA7gBA;EACE,oCAAA;AAghBF;;AA7gBA;EACE,oCAAA;AAghBF;;AA7gBA;EACE,sCAAA;AAghBF","sourcesContent":["/* Ids Switch Component */\n@use '../../themes/mixins/ids-label-position-mixin.scss' as label-position;\n\n$slider-width: var(--ids-space-xl);\n$slider-height: var(--ids-space-md);\n$slider-compact-height: 20px;\n$slider-compact-width: 34px;\n\n// hidden input margin from label position end\n$slider-start-extra-padding: 7px;\n\n.ids-switch {\n  color: var(--ids-switch-label-color-text-default);\n  margin-block-end: var(--ids-space-sm);\n\n  &.no-margins {\n    margin-block-end: var(--ids-space-none);\n  }\n\n  // SWITCH DEFAULT STATE\n  label {\n    cursor: pointer;\n    user-select: none;\n    padding-inline-start: calc($slider-width + var(--ids-space-xs));\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n  }\n\n  input[type='checkbox'] {\n    opacity: 0;\n    width: 0;\n    height: 0;\n\n    ~ .slider {\n      width: $slider-width;\n      height: $slider-height;\n      position: absolute;\n      inset-inline-start: 0;\n      background-color: var(--ids-switch-pole-color-background-default);\n      border-radius: var(--ids-border-radius-circle);\n      border: 1px solid var(--ids-switch-pole-color-border-default);\n      box-sizing: border-box;\n      transition: all var(--ids-motion-duration) var(--ids-motion-ease);\n\n      &::after {\n        content: '';\n        width: 20px;\n        height: 20px;\n        position: absolute;\n        inset-inline-start: 1px;\n        top: 1px;\n        background-color: var(--ids-switch-toggle-color-background-default);\n        border-radius: var(--ids-border-radius-circle);\n        box-shadow: 0 0 2px 0 var(--ids-color-neutral-40);\n        transition: all var(--ids-motion-duration) var(--ids-motion-ease);\n      }\n    }\n\n    &:focus {\n      ~ .slider {\n        box-shadow: var(--ids-switch-shadow-focus);\n      }\n    }\n  }\n\n  // SWITCH ON STATE\n  input[type='checkbox']:checked {\n    ~ .slider {\n      border-color: var(--ids-color-action-default);\n      background-color: var(--ids-color-action-default);\n\n      &::after {\n        inset-inline-start: 17px;\n      }\n    }\n  }\n\n  &.compact input[type='checkbox']:checked {\n    ~ .slider::after {\n      inset-inline-start: 15px;\n    }\n  }\n\n  // SWITCH COMPACT STATE\n  &.compact {\n    label {\n      padding-inline-start: calc($slider-compact-width + var(--ids-space-xs));\n    }\n\n    input[type='checkbox'] {\n      ~ .slider {\n        width: $slider-compact-width;\n        height: $slider-compact-height;\n\n        &::after {\n          width: var(--ids-space-sm);\n          height: var(--ids-space-sm);\n        }\n      }\n    }\n  }\n\n  // SWITCH DISABLED STATE\n  &.disabled {\n    opacity: var( --ids-switch-disabled-opacity);\n\n    label {\n      cursor: default;\n    }\n  }\n\n  &.label-state-hidden .label-text {\n    visibility: hidden;\n  }\n\n  &.label-state-collapsed .label-text {\n    display: none;\n  }\n}\n\n\n// label position start\n:host([label-position='start']) {\n  .ids-switch {\n    label {\n      padding-inline-start: 0;\n    }\n\n    &:not(.compact) {\n      label {\n        padding-inline-end: calc($slider-width + var(--ids-space-xs) + $slider-start-extra-padding);\n      }\n    }\n\n    &.compact {\n      label {\n        padding-inline-end: calc($slider-compact-width + var(--ids-space-xs) + $slider-start-extra-padding);\n      }\n    }\n\n    input[type='checkbox'] {\n      margin: 0;\n\n      ~ .slider {\n        inset-inline-start: unset;\n        inset-inline-end: 0;\n      }\n    }\n  }\n}\n\n// sizes\n:host([size]) {\n  &, .ids-switch, label {\n    width: 100%;\n    box-sizing: border-box;\n  }\n}\n\n:host([size='xs']) label {\n  max-width: var(--ids-input-width-10);\n}\n\n:host([size='sm']) label {\n  max-width: var(--ids-input-width-20);\n}\n\n:host([size='mm']) label {\n  max-width: var(--ids-input-width-30);\n}\n\n:host([size='md']) label {\n  max-width: var(--ids-input-width-40);\n}\n\n:host([size='lg']) label {\n  max-width: var(--ids-input-width-50);\n}\n\n:host([size='full']) label {\n  max-width: var(--ids-input-width-full);\n}\n","// Label position styles\n@use '../../themes/mixins/ids-core-mixins' as *;\n\n// Left aligned and Right Aligned Labels\n:host([label-position='inline-start']) {\n  .ids-input,\n  .ids-textarea {\n    display: flex;\n    align-items: var(--ids-label-align-y, center);\n    gap: 8px;\n\n    // Adjust the label\n    label {\n      width: var(--ids-label-width);\n      padding-block: var(--ids-label-padding-block);\n      padding-inline-end: 0;\n      box-sizing: border-box;\n      flex-shrink: 0;\n    }\n\n    // Validation on the bottom\n    .validation-message {\n      width: 100%;\n      margin-block-start: var(--ids-space-2xs);\n\n      @media (max-width: $breakpoint-md) {\n        margin-inline-start: 0;\n      }\n    }\n\n    + .validation-message {\n      min-width: min-content;\n      margin-block-start: calc(0px - var(--ids-space-2xs));\n      margin-inline-start: calc(var(--ids-label-width) + 6px);\n    }\n\n    &.xs + .validation-message {\n      position: relative;\n      inset-inline-start: 6px;\n      margin-inline-start: calc(var(--ids-label-width));\n    }\n\n    .ids-label-text {\n      margin-bottom: unset;\n\n      @media (width > $breakpoint-xs) {\n        margin-inline-end: 0;\n      }\n\n      @container (width > $breakpoint-xs) {\n        margin-inline-end: 0;\n      }\n    }\n\n    @media (min-width: $breakpoint-sm) {\n      label {\n        flex: 0 0 auto;\n        margin-bottom: unset;\n        order: 1;\n      }\n\n      .field-container {\n        order: 2;\n      }\n\n      .validation-message {\n        flex: 1 1 100%;\n        min-width: 100%;\n        order: 3;\n        margin-block-start: calc(0px - var(--ids-space-2xs));\n      }\n\n      &.wrapped {\n        .validation-message {\n          margin-block-start: calc(0px - var(--ids-space-2xs));\n          margin-inline-start: calc(var(--ids-label-width) + 6px);\n        }\n      }\n    }\n  }\n\n\n  .ids-checkbox {\n    container-type: inline-size;\n    margin-top: var(--ids-space-00);\n\n    @container (width >= 200px) {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: var(--ids-label-align-y, baseline);\n\n      // Adjust the label\n      label {\n        --ids-checkbox-padding-inline-start: 0;\n\n        padding-block: var(--ids-label-padding-block);\n        padding-inline-end: var(--ids-label-padding-inline-end);\n        box-sizing: border-box;\n      }\n\n      .field-container {\n        flex: 1;\n      }\n\n      .validation-message {\n        width: 100%;\n        margin-inline-start: calc(var(--ids-label-width) + 0.4rem);\n        margin-block-start: 3px;\n      }\n\n      input[type='checkbox'] ~ .checkmark {\n        left: unset;\n        inset-inline-end: -1.5rem;\n      }\n\n      label.required .label-checkbox::after {\n        right: 30px;\n      }\n    }\n  }\n}\n\n// Horizontal aligned: use viewport media query instead of container query\n:host([label-position='inline-start'][horizontal-aligned]) {\n  .ids-checkbox {\n    container-type: normal;\n\n    @media (width <= $breakpoint-xs) {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: var(--ids-label-align-y, baseline);\n\n      label {\n        --ids-checkbox-padding-inline-start: 0;\n\n        padding-block: var(--ids-label-padding-block);\n        padding-inline-end: var(--ids-label-padding-inline-end);\n        box-sizing: border-box;\n      }\n\n      .field-container {\n        flex: 1;\n      }\n\n      .validation-message {\n        width: 100%;\n        margin-inline-start: calc(var(--ids-label-width) + 0.4rem);\n        margin-block-start: 3px;\n      }\n\n      input[type='checkbox'] ~ .checkmark {\n        left: unset;\n        inset-inline-end: -1.5rem;\n      }\n\n      label.required .label-checkbox::after {\n        right: 30px;\n      }\n    }\n  }\n}\n\n:host([label-position='inline-start'][label-alignment=\"end\"]) {\n  .ids-input,\n  .ids-textarea {\n    label {\n      display: inline-flex;\n      align-items: center;\n      justify-content: flex-end;\n\n      @container (width < #{$breakpoint-xs}) {\n        justify-content: flex-start;\n      }\n\n      @media (width < $breakpoint-xs) {\n        justify-content: flex-start;\n      }\n\n      &.required {\n        &::after {\n          margin-inline-end: 0;\n        }\n      }\n    }\n\n    @container (width < #{$breakpoint-xs}) {\n      display: block;\n    }\n\n    @media (width < $breakpoint-xs) {\n      display: block;\n    }\n  }\n\n  .field-container {\n    flex: 1;\n  }\n}\n\n// Label break behavior for inline-start position\n:host([label-position='inline-start'][label-break='shrink-value']:not([validation-message-count])),\n:host([label-position='inline-start'][label-break='shrink-value'][validation-message-count][error-tracker]) {\n  .ids-input,\n  .ids-textarea {\n    display: flex;\n    flex-wrap: nowrap;\n\n    label {\n      flex-shrink: 0;\n    }\n\n    .field-container {\n      min-width: 0;\n      flex: 0 1 auto;\n    }\n\n    // Keep validation messages below the field\n    .validation-message {\n      width: auto;\n      margin-inline-start: 0;\n    }\n  }\n\n  .ids-input:not(.xs) {\n    gap: var(--ids-space-2, 0.5rem);\n  }\n}\n\n// When validation is present with shrink-value, use grid to keep field width stable\n:host([label-position='inline-start'][label-break='shrink-value'][validation-message-count]:not([error-tracker])) {\n  .ids-input,\n  .ids-textarea {\n    display: grid;\n    gap: 0;\n    grid-template-columns: auto minmax(0, 1fr);\n    column-gap: var(--ids-space-2, 0.5rem);\n\n    label {\n      grid-column: 1;\n      grid-row: 1;\n    }\n\n    .field-container {\n      grid-column: 2;\n      grid-row: 1;\n      min-width: 0;\n    }\n\n    .validation-message {\n      grid-column: 1 / -1;\n      grid-row: 2;\n      width: auto;\n      margin-inline-start: 0;\n      margin-block-start: var(--ids-space-2xs);\n    }\n\n    &.wrapped .validation-message {\n      grid-column: 2;\n      margin-inline-start: 0;\n    }\n  }\n}\n\n:host([label-position='inline-start'][label-break='shrink-value']) {\n  @media (width > $breakpoint-xs) {\n    .ids-radio-group {\n      display: flex;\n      align-items: var(--ids-label-align-y, baseline);\n\n      ids-text.group-label-text {\n        width: var(--ids-label-width);\n        flex-shrink: 0;\n      }\n\n      slot {\n        display: flex;\n        flex-direction: column;\n        flex-shrink: 0;\n      }\n    }\n  }\n\n  @media (width < $breakpoint-xs) {\n    .ids-input,\n    .ids-textarea {\n      display: block;\n    }\n  }\n\n  @container (width < #{$breakpoint-xs}) {\n    .ids-input,\n    .ids-textarea {\n      flex-wrap: wrap;\n    }\n  }\n}\n\n:host([label-position='inline-start'][label-break='shrink-label']) {\n  @media (width > $breakpoint-xs) {\n    .ids-radio-group {\n      display: flex;\n      align-items: var(--ids-label-align-y, baseline);\n\n      ids-text.group-label-text {\n        width: var(--ids-label-width);\n        flex: 0 1 auto;\n      }\n\n      slot {\n        display: flex;\n        flex-direction: column;\n        flex-shrink: 0;\n      }\n    }\n  }\n}\n\n:host([label-position='inline-start'][label-break='break']) {\n  .ids-input,\n  .ids-textarea {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n\n    label {\n      width: auto;\n      flex-shrink: 0;\n    }\n\n    .field-container {\n      min-width: 0;\n      flex: 0 1 auto;\n    }\n\n    // Keep validation messages below the field\n    .validation-message {\n      width: auto;\n      margin-inline-start: 0;\n    }\n  }\n}\n\n:host([label-position='inline-start'][label-width=\"0px\"]),\n:host([label-position='inline-start'][label-width=\"0\"]) {\n  // When a label is \"inline-start\" and `label-width=\"0px\"` simply don't display it\n  .ids-label-text {\n    display: none;\n  }\n}\n\n\n// Label break behavior for inline-end position\n:host([label-position='inline-end'][label-break='shrink-value']) {\n  .ids-input,\n  .ids-textarea {\n    display: flex;\n\n    label {\n      flex-shrink: 0;\n      order: 2;\n    }\n\n    .field-container {\n      min-width: 0;\n      flex: 0 1 auto;\n      order: 1;\n    }\n  }\n\n  .ids-input {\n    gap: var(--ids-space-2, 0.5rem);\n  }\n}\n\n:host([label-position='inline-end'][label-break='shrink-label']) {\n  @media (width > $breakpoint-xs) {\n    .ids-radio-group {\n      display: flex;\n      align-items: var(--ids-label-align-y, baseline);\n\n      ids-text.group-label-text {\n        width: var(--ids-label-width);\n        justify-content: end;\n        flex: 0 1 auto;\n        order: 2;\n      }\n\n      slot {\n        display: flex;\n        flex-direction: column;\n        flex-shrink: 0;\n        order: 1;\n      }\n    }\n  }\n}\n\n:host([label-position='inline-end'][label-break='break']) {\n  .ids-input,\n  .ids-textarea {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n\n    label {\n      width: auto;\n      flex-shrink: 0;\n      order: 2;\n    }\n\n    .field-container {\n      min-width: 0;\n      flex: 0 1 auto;\n      order: 1;\n    }\n\n    // Keep validation messages below the field\n    .validation-message {\n      margin-inline-start: 0;\n      order: 3;\n    }\n  }\n\n  .ids-input {\n    gap: var(--ids-space-2, 0.5rem);\n  }\n}\n\n:host([label-position=\"inline-start\"]) {\n  --ids-label-width: var(--ids-label-width-inline-start);\n}\n\n// When label-wrap constrains the label size, ensure it stays vertically centered\n// instead of stretching to fill the flex container height\n:host([label-position=\"inline-start\"][label-wrap=\"ellipsis-no-stretch\"]),\n:host([label-position=\"inline-start\"][label-wrap=\"wrap-no-stretch\"]) {\n  .ids-input,\n  .ids-textarea {\n    label {\n      align-self: var(--ids-label-align-y, center);\n    }\n\n    .ids-label-text {\n      overflow: visible;\n    }\n  }\n}\n\n// Text area\n@media (width > $breakpoint-sm) {\n  :host([label-position='inline-start']) {\n    .ids-textarea {\n      max-width: calc(370px + var(--ids-label-width));\n\n      .textarea-field {\n        width: calc(370px + var(--ids-label-width));\n      }\n    }\n  }\n}\n\n// Filter field\n@media (width > $breakpoint-sm) {\n  :host([label-position='inline-start']) {\n    .ids-filter-field {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: var(--ids-label-align-y, baseline);\n\n      label {\n        width: var(--ids-label-width);\n        padding-block: var(--ids-label-padding-block);\n        padding-inline-end: var(--ids-label-padding-inline-end);\n        box-sizing: border-box;\n      }\n\n      // Filter field specific rules\n      #operator-button {\n        position: relative;\n        inset-inline-start: var(--ids-label-width);\n      }\n\n      // Validation on the bottom\n      .validation-message {\n        width: 100%;\n        margin-block-start: var(--ids-space-2xs);\n      }\n    }\n  }\n}\n\n// Checkboxes\n:host([label-position='inline-start'][dir='rtl']) {\n  @media (width < $breakpoint-sm) {\n    .ids-checkbox {\n      label {\n        --ids-checkbox-padding-inline-start: inherit;\n      }\n\n      .validation-message {\n        margin-inline-start: initial;\n      }\n    }\n  }\n}\n\n@media (min-width: $breakpoint-sm) {\n  :host([label-position='inline-start'][dir='rtl']) .ids-checkbox {\n    input[type='checkbox'] ~ .checkmark {\n      right: initial;\n    }\n\n    .validation-message {\n      margin-block-start: 0;\n    }\n  }\n}\n\n\n// Radio buttons\n@media (width > $breakpoint-sm) {\n  :host([label-position='inline-start']),\n  :host([label-position='inline-end']) {\n    .ids-radio-group {\n      display: flex;\n      align-items: var(--ids-label-align-y, baseline);\n      gap: var(--ids-space-2, 0.5rem);\n\n      ids-text.group-label-text {\n        min-width: var(--ids-label-width);\n      }\n\n      slot {\n        display: flex;\n        flex-direction: column;\n      }\n    }\n  }\n\n  :host([label-position='inline-end']) .ids-radio-group {\n    ids-text.group-label-text {\n      justify-content: end;\n      order: 2;\n    }\n\n    slot {\n      order: 1;\n    }\n  }\n}\n\n\n@media (width < $breakpoint-sm) {\n  :host([label-position='inline-end']):not([label-break]) {\n    .ids-radio-group {\n      display: flex;\n      align-items: var(--ids-label-align-y, baseline);\n      gap: var(--ids-space-2, 0.5rem);\n      flex-direction: column;\n\n      ids-text.group-label-text {\n        min-width: var(--ids-label-width);\n        order: 2;\n      }\n\n      slot {\n        display: flex;\n        flex-direction: column;\n        order: 1;\n      }\n    }\n  }\n}\n\n// Switch\n@media (width > $breakpoint-sm) {\n  :host([label-position='inline-start']) .ids-switch {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: var(--ids-label-align-y, baseline);\n\n    label {\n      width: var(--ids-label-width);\n      padding-block: var(--ids-label-padding-block);\n      padding-inline-end: var(--ids-label-padding-inline-end);\n      padding-inline-start: 0;\n      box-sizing: border-box;\n    }\n\n    input[type='checkbox'] ~ .slider {\n      left: unset;\n      right: -45px;\n    }\n  }\n\n  :host([label-position='inline-start'][dir='rtl']) .ids-switch {\n    input[type='checkbox'] ~ .slider {\n      left: 45px;\n      right: initial;\n    }\n  }\n}\n\n// Data Label\n@media (width > $breakpoint-sm) {\n  :host([label-position='inline-start']) .ids-data-label {\n    display: flex;\n    flex-direction: row;\n    gap: 8px;\n    align-items: var(--ids-label-align-y, baseline);\n\n    .label {\n      width: var(--ids-label-width);\n      padding-block: var(--ids-label-padding-block);\n      box-sizing: border-box;\n      margin-block-end: 0;\n      white-space: nowrap;\n    }\n\n    .data,\n    .description {\n      display: flex;\n      padding-block: var(--ids-label-padding-block);\n    }\n  }\n}\n\n// Responsive behavior\n@media (max-width: $breakpoint-xs) {\n  :host([label-position=\"inline-start\"]) {\n    .ids-input,\n    .ids-textarea,\n    .ids-filter-field {\n      display: block;\n      flex-direction: column;\n      align-items: unset;\n\n      label {\n        width: auto;\n        text-align: start;\n        padding-inline: 0;\n      }\n\n      .validation-message {\n        margin-inline-start: 0;\n      }\n    }\n  }\n\n  :host([label-position=\"inline-end\"]) {\n    .ids-input,\n    .ids-textarea,\n    .ids-filter-field {\n      display: block;\n      flex-direction: column;\n      align-items: unset;\n      gap: var(--ids-space-2, 0.5rem);\n\n      label {\n        width: auto;\n        text-align: start;\n        padding-inline: 0;\n      }\n\n      .validation-message {\n        margin-inline-start: 0;\n      }\n    }\n  }\n}\n\n// Just the label width\n:host {\n  .ids-input,\n  .ids-textarea,\n  .ids-checkbox,\n  .ids-radio,\n  .ids-switch,\n  .ids-data-label,\n  .ids-filter-field {\n    label,\n    .label {\n      width: var(--ids-label-width);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
